module.exports = __webpack_public_path__ + "img/index-start.dfe56202.png";